import React from "react"
import BannerGame from "../commonComponents/BannerGame"
import allGames from "../assets/mock/db/games/all.json"

function FreeGames(props) {
    const game = allGames[0]
    console.log('inside free game container')
    return (
        <React.Fragment>
            <BannerGame game={game}/>
        </React.Fragment>
    )
}

export default FreeGames